import { ReactElement, ReactNode } from 'react';
import cn from 'classnames';
import { WarningCircleIcon } from '@phosphor-icons/react';

import styles from './Callout.module.scss';

export interface CalloutProps {
  children: ReactNode;
  classNames?: string | string[];
}

const Callout = ({
  children,
  classNames,
}: CalloutProps): ReactElement | null => {
  if (!children) {
    return null;
  }

  return (
    <div role="alert" className={cn(styles.callout, classNames)}>
      <div className={styles.messageWrapper} aria-live="polite">
        <span className={styles.icon}>
          <WarningCircleIcon
            width={20}
            height={20}
            color="var(--neutrals-900)"
          />
        </span>
        <div>{children}</div>
      </div>
    </div>
  );
};

export default Callout;
